<bb-card-loading *ngIf="loading"></bb-card-loading>
<p-chart *ngIf="!loading && !!data" type="pie" [data]="data"></p-chart>

<ion-item *ngIf="!loading && !data">
    No data.
</ion-item>

<ion-item *ngIf="!loading && error">
    <ion-text color="danger">Could not load data.</ion-text>
</ion-item>
